(() => {
  const initialize = (root) => {
    if (root.dataset.customizationInitialized === 'true') return;
    root.dataset.customizationInitialized = 'true';

    root.querySelectorAll('[data-upload-field]').forEach((uploadField) => {
      const input = uploadField.querySelector('input[type="file"]');
      const fileName = uploadField.querySelector('[data-file-name]');
      const counter = uploadField.querySelector('[data-upload-counter]');
      const error = uploadField.querySelector('[data-upload-error]');
      const previews = uploadField.querySelector('[data-upload-previews]');
      if (!input || !fileName || !counter || !error || !previews) return;

      const propertyName = uploadField.dataset.uploadProperty || 'Upload';
      const maximum = Number.parseInt(uploadField.dataset.maxFiles || '1', 10);
      const maxFiles = Number.isFinite(maximum) && maximum > 0 ? maximum : 1;
      const productInformation = root.closest('.product-information') || root.closest('.shopify-section');
      const productForm = productInformation?.querySelector('product-form-component form');
      const productFormId = productForm?.id;
      let storedFiles = [];
      let previewUrls = [];
      const isRequired = input.required;
      input.required = false;

      const fileKey = (file) => [file.name, file.size, file.lastModified, file.type].join('::');

      const syncSubmissionInputs = () => {
        uploadField.querySelectorAll('[data-upload-property-input]').forEach((element) => element.remove());
        storedFiles.forEach((file, index) => {
          const transfer = new DataTransfer();
          transfer.items.add(file);
          const propertyInput = document.createElement('input');
          propertyInput.type = 'file';
          propertyInput.name = `properties[${propertyName} ${index + 1}]`;
          if (productFormId) propertyInput.setAttribute('form', productFormId);
          propertyInput.setAttribute('data-upload-property-input', '');
          propertyInput.hidden = true;
          propertyInput.files = transfer.files;
          uploadField.append(propertyInput);
        });
      };

      const update = () => {
        const exceedsMaximum = storedFiles.length > maxFiles;
        const requiredMissing = isRequired && storedFiles.length === 0;
        const message = exceedsMaximum
          ? `${root.dataset.maximumFiles || 'You can upload a maximum of'} ${maxFiles}.`
          : requiredMissing
            ? root.dataset.requiredFile || 'Please select at least one file.'
            : '';

        input.setCustomValidity(message);
        error.textContent = exceedsMaximum ? message : '';
        error.hidden = !exceedsMaximum;
        fileName.textContent = storedFiles.length === 0
          ? root.dataset.noFile || 'No file chosen'
          : storedFiles.length === 1
            ? storedFiles[0].name
            : `${storedFiles.length} ${root.dataset.filesSelected || 'files selected'}`;
        counter.textContent = `${storedFiles.length} / ${maxFiles} ${root.dataset.filesSelected || 'files selected'}`;
        syncSubmissionInputs();

        previewUrls.forEach((url) => URL.revokeObjectURL(url));
        previewUrls = [];
        previews.replaceChildren();
        storedFiles.forEach((file, index) => {
          const item = document.createElement('div');
          item.className = 'product-customization-module__preview';
          if (file.type.startsWith('image/')) {
            const image = document.createElement('img');
            const url = URL.createObjectURL(file);
            previewUrls.push(url);
            image.src = url;
            image.alt = file.name;
            item.append(image);
          } else {
            const name = document.createElement('span');
            name.textContent = file.name;
            item.append(name);
          }
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'product-customization-module__remove';
          remove.setAttribute('aria-label', `${root.dataset.removeFile || 'Remove'} ${file.name}`);
          remove.textContent = '×';
          remove.addEventListener('click', () => {
            storedFiles.splice(index, 1);
            update();
          });
          item.append(remove);
          previews.append(item);
        });
      };

      input.addEventListener('change', () => {
        const known = new Set(storedFiles.map(fileKey));
        Array.from(input.files || []).forEach((file) => {
          const key = fileKey(file);
          if (!known.has(key)) {
            storedFiles.push(file);
            known.add(key);
          }
        });
        input.value = '';
        update();
      });

      productForm?.addEventListener('submit', (event) => {
        update();
        if (!input.checkValidity()) {
          event.preventDefault();
          input.reportValidity();
        }
      }, true);

      update();
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-product-customization]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
